// Cuántas hojas (Excel) o archivos (varios CSV) se procesan a la vez, para
// no saturar los servicios. Mismos valores que acepta el backend
// (ingestion_batch_size en whisperbi-back-security: source-connections y
// file-ingestion::_try_advance_chain).
export const DEFAULT_INGESTION_BATCH_SIZE = 4;

export const INGESTION_BATCH_OPTIONS = [
    { value: 1, sheetsLabel: 'Una por una', filesLabel: 'De archivo en archivo' },
    { value: 4, sheetsLabel: 'En bloques de 4 hojas', filesLabel: 'En bloques de 4 archivos' }
];

export const INGESTION_BATCH_HELP =
    'Una por una es más lento pero no satura los servicios ni el límite por minuto de tu plan; ' +
    'en bloques de 4 termina antes.';
